'use strict';
module.exports = false;



// WEBPACK FOOTER //
// ./~/core-js/internals/is-pure.js